import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import emailVerifyDark from "../../images/oc-email-verification-dark.svg";
import emailVerifyLight from "../../images/oc-email-verification.svg";
import LanguageContext from "../../utils/Contexts/LanguageContext";

function VerifyEmail({ formData }) {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!formData?.username) {
      navigate("/sign-in")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData])

  return (
    <div
      className="w-100 content-space-t-4 content-space-t-lg-2 content-space-b-1"
      style={{ maxWidth: "25rem" }}
    >
      <div className="text-center">
        <div className="mb-4">
          <img
            className="avatar avatar-xxl avatar-4x3"
            src={emailVerifyLight}
            alt="Description"
            data-hs-theme-appearance="default"
          />
          <img
            className="avatar avatar-xxl avatar-4x3"
            src={emailVerifyDark}
            alt="Description"
            data-hs-theme-appearance="dark"
          />
        </div>
        <h1 className="display-5">{t("Verify your email")}</h1>
        <p className="mb-1">{t("We've sent a link to your email address:")}</p>
        <span className="d-block text-dark fw-semibold mb-1">
          {formData?.username}
        </span>
        <p>{t("Please follow the link inside to continue.")}</p>
        <div className="mt-4 mb-3">
          {/* eslint-disable-next-line */}
          <a className="btn btn-primary" onClick={() => navigate("/sign-in")}>
            {t("Skip now")}
          </a>
        </div>
        <p>
          {t("Didn't receive an email?")}{" "}
          {/* eslint-disable-next-line */}
          <a
            onClick={() => navigate("/resend-email")}
            style={{ color: "#377dff", cursor: "pointer" }}
          >
            {t("Resend")}
          </a>
        </p>
      </div>
    </div>
  );
}
export default VerifyEmail;
